__turbopack_context__.v({
  "className": "apercuitalic_cbf2468f-module__MNV9zW__className",
  "variable": "apercuitalic_cbf2468f-module__MNV9zW__variable",
});
